import { BASE_URL } from '../config';

export async function getInventory() {
    try {
        const response = await fetch(BASE_URL + '/products/get', {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
            },
        });

        const responseBody = await response.json();

        if (response.status === 200) {
            return responseBody; // Contains the access and refresh tokens
        } else {
            throw new Error(responseBody.detail || 'Failed to retrieve Products');
        }

    } catch (error) {
        console.error('Request to retrieve Products failed:', error.message);
        throw new Error(`Request to retrieve Products failed: ${error.message}`);
    }
}